import { SOSTOSLISTA_CLIENT_NAME } from 'lib/apollo/s-ostoslista-client-name'

export const shoppingListsQueryContext = {
  context: {
    clientName: SOSTOSLISTA_CLIENT_NAME,
  },
}
